<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { setToken, setAdminToken } from '@/utils/auth';

export default {
  created() {
    this.$router.onReady(() => {
      const { id } = this.$route.params;
      const { token, type, admin, showtexteditor, isHistory } = this.$route.query;
      const isAdmin = admin === '1' || admin === 1 || admin === true;

      window.isAdmin = isAdmin;
      if (isAdmin && token) {
        setAdminToken(token);
      } else if (type === '1' && token) {//来自运营后台
        window.rootToken = token;
      } else if (token) {
        setToken(token);
      }

      if (showtexteditor) {
        // 是否为本公司运营人员
        window.isOperator = true;
      } else {
        window.isOperator = false;
      }

      this.setScene({ sceneId: id, isHistory: isHistory === '1' });
    })
  },
  computed: {
    ...mapState('user', [
      "company",
    ]),
	},
  watch: {
    company: {
      handler(newVal) {
        // ID：300203，需要把title，换成“智能体设计”字样
        if (newVal.id === 300203) {
          document.title = '智能体设计';
        }
      },
      deep: true,
    }
  },
  methods: {
    ...mapActions('scene', ['setScene']),
  }
}
</script>
<style lang="scss">
body, html {
  padding: 0;
  margin: 0;
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

#nav {
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.flex {
  display: flex;
}
.flex-justify-center {
  justify-content: center;
}
.flex-end {
  justify-content: flex-end;
}
.highlight {
        color: red;
        font-weight: bold;
    }
</style>
